import { defineFcm } from '../shared/factory';

export const FCM_PROMOTIONS_INELIGIBLE_PETITION_REFUNDS_ENABLED = defineFcm(
	'promotions_ineligible_petition_refunds_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig();
